import { render, staticRenderFns } from "./FormInscriptionFile.vue?vue&type=template&id=474e8015&scoped=true&"
var script = {}
import style0 from "./FormInscriptionFile.vue?vue&type=style&index=0&id=474e8015&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474e8015",
  null
  
)

export default component.exports